import { JkEnvironment, jkRestReturn } from "jk-service";
import { AgCheckBoxEditor, AgTextAreaEditor } from "jk-service";
import { jkLib } from "jk-service";
import { Mtrwl } from "../entity/Mtrwl-angular";
import { MtrwlServicePkg } from "./mtrwlPkg.service";
//import { environment } from 'jk-service';


export class MtrwlService extends MtrwlServicePkg {
  override async newRecord(newItem: Mtrwl): Promise<Mtrwl> {
    await super.newRecord(newItem);
    if (this.programId === 'stock') {

      if (newItem.WL001.length <= 10)
        newItem.WL010 = newItem.WL001; // 股票代號
    }
    newItem.WL002 = this.FindMaxSeq(); // ###
    newItem.WL003 = Number(newItem.WL002);
    newItem.WL005 = jkLib.nowDate();
    newItem.WL006 = new Date();
    return newItem;
  }
  async toggleStar(item: any): Promise<void> {
    if (item.WL008 === 'Y') item.WL008 = 'N';
    else item.WL008 = 'Y';
  }
  async toggleStarUpdate(item: any): Promise<void> {
    if (item.WL008 === 'Y') item.WL008 = 'N';
    else item.WL008 = 'Y';
    let key = this.getKeyValues(item);

    await this.updateData(key, item);
    alert('已更新*');
  }
  async toggleTag(item: Mtrwl, isUpdate: boolean): Promise<void> {
    if (item.WL008 === 'Y') item.WL008 = 'N';
    else item.WL008 = 'Y';
    if (isUpdate) {
      await this.toggleTagUpdate(item);
    }
  }
  async toggleTagUpdate(item: any): Promise<void> {
    let key = this.getKeyValues(item);

    await this.updateData(key, item);
    alert('已更新*');
  }
  quillEditorReady(event: any) {
    if (event.text.trim() !== '') {
      this.item.WL013 = event.html;
      this.item.WL004 = event.text;
    }
  }
  textChange($event: string) {
    this.item.WL004 = $event;
  }
  htmlChange($event: string) {
    this.item.WL013 = $event;
  }
  override init() {
    super.init();
    this.columnDefs = [
      { field: "WL008", headerName: "星號", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "WL005", headerName: "日期", headerTooltip: "", width: 120, cellDataType: "text", valueFormatter: (p: any) => { return jkLib.dateField2Display(p.value) }, },
      { field: "WL011", headerName: "tag", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "WL003", headerName: "排序碼", headerTooltip: "", width: 102, cellDataType: "number", },
      {
        field: "WL007", headerName: "主旨", headerTooltip: "", width: 250, cellDataType: "text",
        cellEditor: 'agLargeTextCellEditor', cellRenderer: AgTextAreaEditor,
      },
      {
        field: "WL004", headerName: "內文", headerTooltip: "", width: 400, maxWidth: 1000, cellDataType: "text",
        cellEditor: 'agLargeTextCellEditor', cellRenderer: AgTextAreaEditor,
      },
      { field: "WL010", headerName: "股票代號", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "WL009", headerName: "來源單號", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "WL002", headerName: "序號", headerTooltip: "", width: 102, cellDataType: "text", editable: true, },
      { field: "CREATE_DATE", headerName: "建檔日期", headerTooltip: "", width: 110, cellDataType: "text", editable: false },
      { field: "WL012", headerName: "格式", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "WL013", headerName: "html內文", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "WL001", headerName: "單號", headerTooltip: "", width: 230, cellDataType: "text", hide: true },
      { field: "WL006", headerName: "Date", headerTooltip: "", width: 80, cellDataType: "date", valueFormatter: (p: any) => { return jkLib.datetimeFormatter(p.value) }, }, // ***
    ];
  }

  override async doBeforePost(item: Mtrwl, ret: jkRestReturn): Promise<boolean> {
    let bool = await super.doBeforePost(item, ret);
    if (bool) {
      item.WL006 = new Date();
    }
    return bool;
  }
  override async doMyOk(): Promise<boolean> {
    return super.doMyOk();
  }

}
